/**
 *
 * AppPreloader
 * -----------------
 * Note: For the container HTML, in which this component should be located,
 * it is necessary to specify the 'position' property with the value 'relative' in the styles
 *
 */

import { FC } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useStyles } from './styles';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';

export const AppPreloader: FC = observer(() => {
  const classes = useStyles();
  const {
    appPreloaderStore: { show, type, size },
  } = useStore();

  return show ? (
    <div className={classes.wrap}>
      <div className={classes.preloaderContainer}>
        <div className={type === 'outside' ? classes.boxOutside : undefined}>
          <CircularProgress size={size === 'big' ? 40 : 20} thickness={size === 'big' ? 4 : 3} />
        </div>
      </div>
    </div>
  ) : null;
});
